
import { defineComponent, PropType, reactive, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const PlayerRepository = RepositoryFactory.get('player')

import { Player } from '@/types/player'

import _ from 'lodash.clonedeep'

export default defineComponent({
  inheritAttrs: false,
  components: {
  },
  props: {
    teamPlayers: {
      type: Array as PropType<Player[]>,
      required: true
    }
  },
  setup(props) {
    const route = useRoute()
    const store = useStore()

    onMounted(() => {
      getUnBelongPlayers()
    })

    const players: {
      list: Player[]
      selectedPlayer?: Player
    } = reactive({
      list: [],
      selectedPlayer: undefined
    })

    watch(
      () => props.teamPlayers,
      () => {
        players.list = _(props.teamPlayers)
      },
      { immediate: true, deep: true }
    )

    const playerFormAdd = reactive({
      name: '',
      isCompleted: true
    })

    watch(
      () => [playerFormAdd.name],
      () => {
        playerFormAdd.isCompleted = (playerFormAdd.name !== '') ? true : false
      },
      { immediate: true },
    )

    const addPlayer = async () => {
      try {
        const { team_id } = route.params

        const dataObj = {
          team_id: team_id,
          name: playerFormAdd.name,
        }

        const res = await PlayerRepository.postPlayer(dataObj)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          playerFormAdd.name = ''
          players.list.push(data.new)

          store.dispatch('addFlashMessage', {
            type: 'success',
            message: '選手を登録しました'
          })
        }
      } catch (error) {
        //
      }
    }

    const searchForm = reactive({
      keyword: ''
    })

    watch(
      () => searchForm,
      () => {
        getUnBelongPlayers()
      },
      { deep: true }
    )

    const unBelongPlayers: {
      list: Player[]
      selectedPlayer?: Player

      limit: number
      totalNumber: number
    } = reactive({
      list: [],
      selectedPlayer: undefined,

      limit: 6,
      totalNumber: 0
    })

    const getUnBelongPlayers = async () => {
      try {
        resetSelectedUnBelongPlayer()

        const { team_id } = route.params

        const dataObj = {
          team_id: team_id,
          keyword: searchForm.keyword,
          limit: unBelongPlayers.limit
        }

        const res = await PlayerRepository.getUnBelongPlayers(dataObj)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          unBelongPlayers.list = data.players
          unBelongPlayers.totalNumber = data.total_number - data.players.length
        }
      } catch (error) {
        //
      }
    }

    const toggleUnBelongPlayer = (player: Player) => {
      if (unBelongPlayers.selectedPlayer?.id === player.id) {
        resetSelectedUnBelongPlayer()
      } else {
        unBelongPlayers.selectedPlayer = player
      }
    }

    const resetSelectedUnBelongPlayer = () => {
      unBelongPlayers.selectedPlayer = undefined
    }

    const movePlayer = async () => {
      try {
        const { team_id } = route.params

        const dataObj = {
          team_id: team_id,
          player_id: unBelongPlayers.selectedPlayer?.id,
        }

        const res = await PlayerRepository.movePlayer(dataObj)

        if (res.status === 200) {
          const r = res.data
          const data = r.data

          searchForm.keyword = ''
          players.list.push(data.player)
          getUnBelongPlayers()

          store.dispatch('addFlashMessage', {
            type: 'success',
            message: '他のチームから選手を移籍しました'
          })
        }
      } catch (error) {
        //
      }
    }

    return {
      players,

      playerFormAdd,
      addPlayer,

      unBelongPlayers,
      searchForm,
      getUnBelongPlayers,

      toggleUnBelongPlayer,
      movePlayer
    }
  }
})
